import { EditingInputOnClick } from 'components/EditingInput'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import React, { CSSProperties } from 'react'
import { KVPolygon } from 'types'

export const PolygonNotesInput: React.FC<{
  selectedPolygon: KVPolygon
}> = ({ selectedPolygon }) => {
  const { updatePolygon } = useKestrelViewerContext()

  const setNotes = (s: string) => {
    updatePolygon(
      selectedPolygon,
      'polygonNotes',
      (a) => {
        a.notes = s
        return a
      },
      s
    )
  }

  const inputStyles = {
    minHeight: '44px',
    padding: '4px',
  } as CSSProperties

  const divStyles = {
    border: '0.5px solid gray',
    padding: '4px',
    minHeight: '44px',
    cursor: 'text',
    width: '100%',
  } as CSSProperties

  return (
    <EditingInputOnClick
      key={selectedPolygon.id}
      divStyle={divStyles}
      inputStyle={inputStyles}
      value={selectedPolygon.notes}
      setValue={(s) => setNotes(s)}
    />
  )
}
